export enum FormName {
    CRM = 'crmType',
    MEDIA = 'mediaType',
    PRODUCT = 'productType'
}